export function getShipCrewChatUrl(value: unknown): string | null {
  if (typeof value !== 'string' || !value.trim()) return null;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.username || url.password || url.search || url.hash
      || !/^\/chat\/c\/(?:[a-zA-Z0-9_-]+\/)?[1-9]\d*\/?$/.test(url.pathname)) return null;
    return url.href;
  } catch {
    return null;
  }
}

export function getReportPagePath(path: string): string {
  if (!/^\/(?!\/)[A-Za-z0-9_./%~-]{0,499}$/.test(path)) return '/';
  // Decode before classifying private routes, but preserve the original public URL.
  // Bound repeated encoding and fail closed for malformed/ambiguous paths.
  let decoded = path;
  try {
    for (let pass = 0; pass < 5 && decoded.includes('%'); pass++) {
      decoded = decodeURIComponent(decoded);
    }
    if (decoded.includes('%') || !/^\/(?!\/)/.test(decoded) || /[\\?#]/.test(decoded) || [...decoded].some(character => character.charCodeAt(0) < 32)) return '/';
    for (const candidate of [decoded, new URL(decoded, 'https://ark.invalid').pathname]) {
      if (/^\/chat\/invite(?:\/|$)/i.test(candidate)) return '/chat/invite/redacted';
      if (/^\/search(?:\/|$)/i.test(candidate)) return '/search/redacted';
      if (/^\/payment(?:\/|$)/i.test(candidate)) return '/payment/redacted';
      if (/^\/(?:password|verify|auth)(?:\/|$)/i.test(candidate)) return '/auth/redacted';
    }
  } catch {
    return '/';
  }
  return path;
}
